import { render, staticRenderFns } from "./limit_time_discount_detail.vue?vue&type=template&id=340b404d"
import script from "./limit_time_discount_detail.vue?vue&type=script&lang=js"
export * from "./limit_time_discount_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports